export function hasUnpairedDoubleAsterisks(text: string) {
  const stack = [];
  let pos = 0;

  while (pos < text.length) {
    if (text.substr(pos, 2) === "**") {
      if (stack.length > 0) {
        const start = stack.pop();
        const content = text.slice((start || 0) + 2, pos);
        if (content === "") return true; // 无效配对：**空内容**
      } else {
        stack.push(pos); // 记录起始位置
      }
      pos += 2;
    } else {
      pos++;
    }
  }

  return stack.length > 0; // 存在未闭合的 **
}

export function countSingleAsterisksSafe(text: string) {
  let count = 0;
  let i = 0;
  while (i < text.length) {
    if (text[i] === "*") {
      if (i + 1 < text.length && text[i + 1] === "*") {
        i += 2; // 跳过成对 **
      } else {
        count++;
        i++;
      }
    } else {
      i++;
    }
  }
  return count;
}
